import type { ReactNode } from 'react';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import type { Country, DefaultInputComponentProps } from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

import ErrorMessage from '../ErrorMessage/ErrorMessage';

import { FormPhoneInputStyled, LabelStyled, RequiredSignStyled } from './FormPhoneInput.styled';

type FormPhoneInputPropsT<FormValuesT> = Omit<
  DefaultInputComponentProps,
  'placeholderText' | 'onChange'
> & {
  name: Path<FormValuesT>;
  placeholder?: string;
  label?: string | ReactNode;
  isRequired?: boolean;
  defaultCountry?: Country;
};

const FormPhoneInput = <FormValuesT,>({
  name,
  label,
  isRequired = false,
  ...restFormPhoneInputProps
}: FormPhoneInputPropsT<FormValuesT>): JSX.Element => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <>
      {label && (
        <LabelStyled htmlFor={name}>
          {label}
          {isRequired && <RequiredSignStyled>&nbsp;*</RequiredSignStyled>}
        </LabelStyled>
      )}
      <FormPhoneInputStyled
        name={name}
        control={control}
        data-testid="phone-number"
        {...restFormPhoneInputProps}
      />
      {errors[name] && <ErrorMessage error={errors[name]?.message as Path<FormValuesT>} />}
    </>
  );
};

export default FormPhoneInput;
